import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-error',
  imports: [],
  templateUrl: './auth-error.component.html',
  styleUrl: './auth-error.component.css'
})
export class AuthErrorComponent {

}
